import { UPDATE_ALERT, UPDATE_ALERT_CLOSE, OPEN_ORDER_SUCCESS, CLOSE_ORDER_SUCCESS } from "../../actionTypes/spinner";

// Worker triggering actionCreators


// Redux state changing actionCreators

export function updateAlert(message, color) {
    return { type: UPDATE_ALERT, message, color  };
}

export function updateAlertClose() {
    return { type: UPDATE_ALERT_CLOSE };
}

// order: { cOrderID, nAmount } — both optional
export function openOrderSuccess(order = {}) {
    return { type: OPEN_ORDER_SUCCESS, order };
}

export function closeOrderSuccess() {
    return { type: CLOSE_ORDER_SUCCESS };
}
